import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';
import type { OverquotaClearDeleteConfirmDialogProps } from 'reactApp/sections/QuotaLanding/OverquotaClearDeleteConfirmDialog/OverquotaClearDeleteConfirmDialog';

export const openOverquotaClearDeleteConfirmDialog = (data: OverquotaClearDeleteConfirmDialogProps) =>
    openPopupHelper({
        popupName: popupNames.OVERQUOTA_CLEAR_DELETE_CONFIRM,
        data,
    });
